import script from "./colour-picker.vue?vue&type=script&setup=true&lang=ts"
export * from "./colour-picker.vue?vue&type=script&setup=true&lang=ts"

import "./colour-picker.vue?vue&type=style&index=0&id=49edc930&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49edc930"]])

export default __exports__